import RelatorioPowerBi from "./RelatorioPowerBi"

const RelatorioPowerBiWrapper = ({...rest}) =>{
    return(
        <RelatorioPowerBi key={rest.location.pathname} {...rest}/>
    )
}

export default RelatorioPowerBiWrapper;